import { render, staticRenderFns } from "./BeakerAndFlaskSvg.vue?vue&type=template&id=77d2e8c3&"
import script from "./BeakerAndFlaskSvg.vue?vue&type=script&lang=ts&"
export * from "./BeakerAndFlaskSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('77d2e8c3', component.options)
    } else {
      api.reload('77d2e8c3', component.options)
    }
    module.hot.accept("./BeakerAndFlaskSvg.vue?vue&type=template&id=77d2e8c3&", function () {
      api.rerender('77d2e8c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/svgs/BeakerAndFlaskSvg.vue"
export default component.exports